import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-rating-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Input('question') question: string = '';
  @Input('currentItem') currentItem: number = 0;
  @Input('count') count: number = 0;

  constructor() { }

  ngOnInit() {
  }

}
